<form (ngSubmit)="submitForm()" [formGroup]="confirmationForm" class="confirmation-form">
  <form-base (modelChanges)="updateModel($event)" [formElements]="fields" [form]="confirmationForm" [model]="model" />
  <div class="button-row">
    <button (click)="goBack()" mat-raised-button type="button">Zurück</button>
    <button
      [disabled]="confirmationForm.pristine || confirmationForm.invalid"
      color="primary"
      mat-flat-button
      type="submit">
      Weiter
    </button>
  </div>
</form>
